import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Account created");
      navigate(location.state?.from || "/book", { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell eyebrow="Join the factory" title="Create account" testId="register-page">
      <form onSubmit={submit} className="space-y-6" data-testid="register-form">
        <div className="space-y-2">
          <Label htmlFor="name">Name</Label>
          <Input id="name" required value={form.name} onChange={set("name")} data-testid="register-name-input" className="h-12" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={form.email} onChange={set("email")} data-testid="register-email-input" className="h-12" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="register-password-input" className="h-12" />
          <p className="text-xs text-zinc-500">At least 6 characters.</p>
        </div>
        {error && <p className="text-sm text-[#FF3333]" data-testid="register-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-riot w-full" data-testid="register-submit-btn">
          {loading ? "Creating…" : "Create account"}
        </button>
        <p className="text-sm text-zinc-400">
          Already a member?{" "}
          <Link to="/login" state={location.state} className="text-white underline-offset-4 hover:text-[#FF3333] hover:underline" data-testid="register-login-link">
            Log in
          </Link>
        </p>
      </form>
    </AuthShell>
  );
}
